var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .125h128v128H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.707 18.709h59.2c4.062 0 7.508 3.323 7.508 7.508v67.077l-6.154 7.63-6.154-7.384-6.03 7.384-5.908-7.138-5.908 7.015-5.785-7.015-5.784 7.015-5.908-7.138-5.785 7.015-6.277-7.507V35.94",
    stroke: "#4C565C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.953 42.463H18.461V25.602a8.247 8.247 0 0 1 8.246-8.247h.123a8.247 8.247 0 0 1 8.246 8.247v16.861h-.123z",
    fill: "#4C565C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4 33.478h30.893M46.4 54.155h30.893M46.4 43.817h18.462",
    stroke: "#4C565C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.416 110.402c8.225 0 14.892-6.668 14.892-14.892 0-8.225-6.667-14.893-14.892-14.893S78.523 87.285 78.523 95.51c0 8.225 6.668 14.893 14.893 14.893z",
    fill: "#34A853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m87.016 95.756 4.061 4.061 8.615-8.615",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4 73.97c2.093-3.076 5.416-7.876 6.893-7.507 1.846.492.615 7.015 1.723 7.138 1.108.123 3.446-5.907 5.415-5.907 1.723 0 .739 6.03 2.708 6.153 1.108.123 2.954-1.353 6.03-10.707",
    stroke: "#4C565C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillPaid);
export default __webpack_public_path__ + "static/media/bill_paid.02c865298beb0179fb9b30baa92f5bcd.svg";
export { ForwardRef as ReactComponent };